import { useNavigate, useLocation } from "react-router-dom";
import useBodyScrollLock from "hooks/useBodyScrollLock";
import { openMemberType } from "util/openMemberType";
import RoleChangeModal from "components/ui/RoleChangeModal";
import { roleGateCopy } from "common/roleGateCopy";
import { useAuth } from "context/AuthContext";

/**
 * 권한 거부 안내 모달. usePermission().notice 를 그대로 받아 렌더.
 *  - 비회원: "로그인하기" CTA
 *  - 로그인했지만 유형 부족: "회원 유형 전환" CTA (→ 네이티브 회원유형 팝업)
 *
 *   const { notice, closeNotice } = usePermission();
 *   <RoleNoticeModal notice={notice} onClose={closeNotice} />
 */
export default function RoleNoticeModal({ notice, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isShow = !!notice;
  const loggedIn = notice?.loggedIn;
  const { activeType } = useAuth();
  useBodyScrollLock(isShow);

  const handleCta = () => {
    onClose?.();
    if (loggedIn) {
      openMemberType(navigate, activeType);
    } else {
      const redirect = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?redirect=${redirect}`);
    }
  };

  const copy = roleGateCopy({ action: notice?.action, activeType, message: notice?.message });
  const isPostingFlow = /^\/(?:muyeon\/)?(jobs|subs|casting)(\/|$)/.test(location.pathname)
    || /^(job|sub|casting)\./.test(notice?.action || "");
  const leavePosting = () => {
    onClose?.();
    navigate(-1);
  };
  if (!loggedIn || !isPostingFlow) return (
    <div data-id="role-notice" className={`modal-dimmed ${isShow ? "is-show" : ""}`}>
      <div className="modal"><div className="tit-box"><p>{notice?.message}</p></div><div className="btn-group">
        <button type="button" className="btn-md outlined" onClick={onClose}>{loggedIn ? "닫기" : "돌아가기"}</button>
        <button type="button" className="btn-md filled primary" onClick={handleCta}>{loggedIn ? "회원유형 추가하기" : "로그인하기"}</button>
      </div></div>
    </div>
  );
  return <RoleChangeModal isShow={isShow} title={copy.title} description={copy.description}
    roles={[]} onAdd={handleCta} onBack={leavePosting} />;
}
